import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  IconButton,
  Collapse,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormControl,
  InputLabel,
  Tooltip,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KnowledgeBaseTabs from "../KnowledgeBaseFormTabs";
import {
  KnowledgeBase,
  KnowledgeBaseCombine,
  knowledgeDoc,
  KnowledgeWebsite,
} from "../../../Shared-ui/Types/KnowledgeBase";
import {
  isOnlyAlphabets,
  isOnlyAlphabetsNumbers,
} from "../../../Shared-ui/utils/Common/Common";
import AdvancedOptions from "./AdvancedOptions";
import { NotSelected } from "../../../Constant/Setting";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { KNOWLEDGE, KNOWLEDGE_BASE, MODEL_EMBEDDERS } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseMultipartInstance from "../../../Services/AxiosInstance/BaseMultupartInstance";
import { set } from "date-fns";
import { tr } from "date-fns/locale";
import KnowledgeBases from "../../Pages/KnowledgeBases";

interface MyComponentProps {
  open: boolean;
  handleClose: () => void;
  knowledgeBase: KnowledgeBase | null;
}

const KnowledgeBaseForm: React.FC<MyComponentProps> = (props) => {
  const knowledgeBaseinitial: KnowledgeBase = {
    name: "",
    description: "",
    type: "pdf",
    is_active: true,
    config: {
      chunk_overlap: 200,
      chunk_size: 1000,
      chunking: {
        type: "fixed_size",
      },
      embedder: {
        type: "OpenAI",
        model: "text-embedding-3-small",

      },
      vector_db: {
        type: "qdrant",
        qdrant: {
          collection_name: "my_collection",
          url: "http://localhost:6333",
        },
      },

    },
    embedder_model: "OpenAI Embedder",
    api_key: "",
  };
  const knowledgeBaseCombineInitial = {
    source_knowledge_base_ids: [],
  };
  const knowledgeBaseErrInitial = {
    name: { error: "", value: false },
    description: { error: "", value: false },
    vector_db: { error: "", value: false },
    embedder: { error: "", value: false },
    chunking: { error: "", value: false },
  };

  const dispatch = useDispatch();
  const [knowledgeBase, setKnowledgeBase] =
    useState<KnowledgeBase>(knowledgeBaseinitial);
  console.log(knowledgeBase, "knowledgeBase");
  const [knowledgeBaseCombine, setKnowledgeBaseCombine] =
    useState<KnowledgeBaseCombine>(knowledgeBaseCombineInitial);
  const [unselectedCombined, setUnselectedCombined] = useState<string[]>([]);
  const [knowledgeBaseId, setKnowledgeBaseId] = useState<string | null>(null);
  const [knowledgeBaseErr, setKnowledgeBaseErr] = useState(
    knowledgeBaseErrInitial
  );
  const [knowledgeBaseDoc, setKnowledgeBaseDoc] = useState<knowledgeDoc>({} as knowledgeDoc);
  const [knowledgeBasWebsite, setKnowledgeBasWebsite] =
    useState<KnowledgeWebsite>({} as KnowledgeWebsite);
  const [knowledgeBaseSharePoint, setKnowledgeBaseSharePoint] = useState<any>({});
  console.log(knowledgeBaseSharePoint, 'knowledgeBaseSharePoint');
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true)
  const [embedders, setEmbedders] = useState<any>([]);
  useEffect(() => {
    // Check if all required agent fields are filled (returns true/false)
    const requiredFieldsFilled =
      !!knowledgeBase.name.trim() && !!knowledgeBase.description.trim()
      && !!knowledgeBase.api_key?.trim();

    // Check if any valid source is provided
    const validSourceUploaded =
      (knowledgeBaseDoc?.files && knowledgeBaseDoc.files.length > 0) ||
      (knowledgeBaseCombine?.source_knowledge_base_ids &&
        knowledgeBaseCombine.source_knowledge_base_ids.length > 0) ||
      (knowledgeBasWebsite?.urls && knowledgeBasWebsite.urls.length > 0) ||
      (knowledgeBaseSharePoint?.files && knowledgeBaseSharePoint.files.length > 0);
    if (!props.knowledgeBase) {
      setDisableSubmit(!(requiredFieldsFilled && validSourceUploaded));
    } else {
      setDisableSubmit(!(requiredFieldsFilled || validSourceUploaded));
    }
  }, [
    knowledgeBase,
    knowledgeBaseDoc,
    knowledgeBaseCombine,
    knowledgeBasWebsite,
    knowledgeBaseSharePoint,
  ]);

  const getKnowledgeBase = async (knowledgeBaseId: string) => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${KNOWLEDGE_BASE}/${knowledgeBaseId}`).then(
        (res) => res?.data
      );
      setKnowledgeBase(data)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  }

  useEffect(() => {
    if (props.knowledgeBase?.id) {
      setKnowledgeBase(props.knowledgeBase);
      // getKnowledgeBase(props.knowledgeBase.id);
      setIsEditing(true);
    } else if (props.open && !props.knowledgeBase?.id) {
      setKnowledgeBase(knowledgeBaseinitial);
    }
  }, [props.knowledgeBase]);

  useEffect(() => {
    getAllEmbedders()

  }, [])

  const getAllEmbedders = async () => {
    try {
      const response = await BaseInstance.get(MODEL_EMBEDDERS);
      setEmbedders(response?.data?.embedders);
      var a = 0;
    } catch (error: any) {
      console.error("Error fetching embedders:", error);
      dispatch(ShowError(error.message || "Failed to fetch embedders"));
    }
  };

  const createKnowledgeBase = async () => {
    if (!validateKnowledgeBase()) return;
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(KNOWLEDGE_BASE, knowledgeBase).then(
        (res) => res?.data
      );
      setKnowledgeBase(data);

      filesUploadKnowledgeBase(data.id);
      if (knowledgeBaseCombine.source_knowledge_base_ids.length > 0) {
        createCombineKnowledgeBase(data.id);
      }
      if (knowledgeBasWebsite.urls && knowledgeBasWebsite.urls.length > 0) {
        processKnowledgeWebsite(data.id);
      }
      if (knowledgeBaseSharePoint?.files && knowledgeBaseSharePoint.files.length > 0) {
        handleSharePointFileRetrieval(knowledgeBaseSharePoint.toolkit_id, data.id);
        processSharePoint(data.id);
      }
      handleCancel();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  // New reusable function for process-all
  const processAllFiles = async (knowledgeId: string) => {
    try {
      const data = await BaseInstance.post(
        `${KNOWLEDGE_BASE}/${knowledgeId}/process-all`
      ).then((res) => res?.data);

      console.log('All files processed successfully:', data);
    } catch (err: any) {
      console.error('Error processing all files:', err);
      dispatch(ShowError(err?.response?.data?.detail));
    }
  };

  const processSharePoint = async (knowledgeId: string) => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(
        `${KNOWLEDGE_BASE}/${knowledgeId}/process-all`,
        knowledgeBaseSharePoint
      ).then((res) => res?.data);

      console.log('SharePoint creation response:', data);
      console.log('Response keys:', Object.keys(data || {}));
      console.log('Looking for tool_id, found:', data?.tool_id);


    } catch (err: any) {
      console.error('Error in processSharePoint:', err);
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  // Add the file retrieval function here
  const handleSharePointFileRetrieval = async (toolId: string, kbId: string) => {
    try {
      dispatch(StartLoading());

      // Query parameters for the URL
      const queryParams = new URLSearchParams();
      queryParams.append('site', knowledgeBaseSharePoint.site);

      // Get server_relative_urls from the files array in state and add as query params
      if (knowledgeBaseSharePoint.files && Array.isArray(knowledgeBaseSharePoint.files)) {
        knowledgeBaseSharePoint.files.forEach((file: any) => {
          if (file.server_relative_url) {
            queryParams.append('server_relative_urls', file.server_relative_url);
          }
        });
      } else {
        // Fallback to default if no files
        dispatch(ShowError('No SharePoint files available for processing'));
        return; // Exit early if no files
      }

      // Form data for the request body (x-www-form-urlencoded)
      const formData = new URLSearchParams();
      formData.append('kb_id', kbId);
      formData.append('description', knowledgeBase.description);
      formData.append('process_immediately', 'false');
      formData.append('auto_process_all', 'false');

      // Use BaseInstance.post like other API calls in the component
      const data = await BaseInstance.post(
        `sharepoint/${toolId}/retrieve-files?${queryParams.toString()}`,
        formData.toString(),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      ).then((res) => res?.data);

      console.log('SharePoint files retrieved successfully:', data);

      // Process all files after retrieval
      await processAllFiles(kbId);

    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };



  const processKnowledgeWebsite = async (knowledgeId: string) => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(
        `${KNOWLEDGE_BASE}/${knowledgeId}/process-websites`,
        knowledgeBasWebsite
      ).then((res) => res?.data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const createCombineKnowledgeBase = async (knowledgeId: string) => {
    try {
      dispatch(StartLoading());
      if (knowledgeId) {
        const data = await BaseInstance.post(
          `${KNOWLEDGE}/${knowledgeId}/combine`,
          knowledgeBaseCombine
        ).then((res) => res?.data);
      }

    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const updateCombineKnowledgeBase = async (knowledgeId: string) => {
    try {
      dispatch(StartLoading());
      if (knowledgeId) {
        const data = await BaseInstance.put(
          `${KNOWLEDGE}/combined/${knowledgeId}`,
          knowledgeBaseCombine
        ).then((res) => res?.data);
      }
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const updateKnowledgeBase = async () => {
    if (!validateKnowledgeBase()) return;
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.put(
        `${KNOWLEDGE_BASE}/${knowledgeBase.id}`,
        knowledgeBase
      ).then((res) => res?.data);
      if (knowledgeBase.type === "combined") {
        updateCombineKnowledgeBase(knowledgeBase.id || "");
      }
      if (knowledgeBasWebsite.urls && knowledgeBasWebsite.urls.length > 0 && knowledgeBase.type === "website") {
        processKnowledgeWebsite(data.id);
      }
      if (knowledgeBaseSharePoint?.files && knowledgeBaseSharePoint.files.length > 0 && knowledgeBase.type === "SHAREPOINT") {
        handleSharePointFileRetrieval(knowledgeBaseSharePoint.toolkit_id, data.id);
        processSharePoint(data.id);
      }
      setKnowledgeBase(data);
      filesUploadKnowledgeBase(data.id);
      handleCancel();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const uploadSingleFile = (file: File, knowledgeId: string) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("description", "");
    formData.append("process_immediately", "false");
    return BaseMultipartInstance.post(
      `${KNOWLEDGE_BASE}/${knowledgeId}/upload`,
      formData
    )
  };

  const filesUploadKnowledgeBase = async (knowledgeId: string) => {
    try {
      dispatch(StartLoading());
      if (knowledgeBaseDoc?.files && knowledgeBaseDoc?.files.length > 0) {
        const uploadPromises = knowledgeBaseDoc?.files.map((file) =>
          uploadSingleFile(file, knowledgeId)
        );
        await Promise.all(uploadPromises);
        await processAllFiles(knowledgeId);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      dispatch(StopLoading());
    }
  };

  const validateKnowledgeBase = () => {
    var error = 0;

    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setKnowledgeBaseErr((prev) => ({
          ...prev,
          [field]: { error: message, value: true },
        }));
        if (["vector_db", "embedder", "chunking"].includes(field)) {
          setShowAdvancedOptions(true);
        }
        error += 1;
      } else {
        setKnowledgeBaseErr((prev) => ({
          ...prev,
          [field]: { error: "", value: false },
        }));
      }
    };

    setError(
      "name",
      !knowledgeBase.name.trim() ||
      !isOnlyAlphabetsNumbers(knowledgeBase.name.trim()),
      "Please enter the name A-z"
    );
    setError(
      "description",
      !knowledgeBase.description.trim(),
      "Please enter the description A-z"
    );
    setError(
      "chunking",
      knowledgeBase.config.chunking.type === NotSelected,
      "Please select chuncking"
    );
    setError(
      "embedder",
      knowledgeBase.config.embedder.model === NotSelected,
      "Please select embedder"
    );
    setError(
      "vector_db",
      knowledgeBase.config.vector_db.type === NotSelected,
      "Please select vector db"
    );

    return error > 0 ? false : true;
  };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setKnowledgeBase((preVal) => {
      if (name === "api_key") {
        return {
          ...preVal,
          [name]: value,
        };
      }

      return {
        ...preVal,
        [name]: value,
      };
    });
  };

  const handleEmbedderSelect = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;

    const selected_option = embedders.find((opt: any) => opt.embedder === value);
    const updatedConfigEmbedder = { ...knowledgeBase.config.embedder, type: selected_option.provider };


    setKnowledgeBase((prevState) => ({
      ...prevState,
      config: {
        ...prevState.config,
        embedder: updatedConfigEmbedder
      },
      [name]: value,
    }));
    var a = 0;
  };



  const handleCancel = () => {
    props.handleClose();
    setKnowledgeBase(knowledgeBaseinitial);
    setKnowledgeBaseCombine(knowledgeBaseCombineInitial);
    setUnselectedCombined([]);
    setKnowledgeBaseDoc({} as knowledgeDoc);
    setKnowledgeBasWebsite({} as KnowledgeWebsite);
    setKnowledgeBaseErr(knowledgeBaseErrInitial);
    setShowAdvancedOptions(false);
    setIsEditing(false);
  };

  return (
    <Dialog open={props.open} onClose={handleCancel} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
        }}
      >
        <Box>
          {isEditing ? "Knowledge settings" : "Create Knowledge"}
          <Typography
            variant="subtitle2"
            color="textSecondary"
            sx={{ mt: 0.5 }}
          >
            Configure the knowledge that your agents can use to perform tasks
          </Typography>
        </Box>
        <IconButton onClick={handleCancel} sx={{ ml: 1 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box>
        <DialogContent>
          <FormControl
            fullWidth
            sx={{ mb: 2 }}
            error={knowledgeBaseErr.name.value}
          >
            <InputLabel
              shrink
              htmlFor="knowledgeBaseName"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Knowledge Name *
            </InputLabel>
            <TextField
              required
              id="name"
              name="name"
              value={knowledgeBase.name}
              onChange={handleChange}
              helperText={knowledgeBaseErr.name.error}
              error={knowledgeBaseErr.name.value}
              inputProps={{ maxLength: 50 }}
              placeholder="Enter knowledge name"
              variant="outlined"
            />
          </FormControl>

          <FormControl
            fullWidth
            sx={{ mb: 1 }}
            error={knowledgeBaseErr.description.value}
          >
            <InputLabel
              shrink
              htmlFor="description"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Description *
            </InputLabel>
            <TextField
              required
              id="description"
              name="description"
              value={knowledgeBase.description}
              placeholder="Enter description"
              onChange={handleChange}
              inputProps={{ maxLength: 255 }}
              helperText={knowledgeBaseErr.description.error}
              error={knowledgeBaseErr.description.value}
              multiline
              rows={2}
              variant="outlined"
            />

            <Box display="flex" justifyContent="flex-end">
              <Typography variant="caption" color="textSecondary" align="right">
                {`${knowledgeBase.description.length} / ${255} characters`}
              </Typography>
            </Box>
          </FormControl>

          <FormControl
            fullWidth
            sx={{ mb: 2 }}
            error={knowledgeBaseErr.description.value}
          >
            <InputLabel
              shrink
              htmlFor="description"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Embedder *
            </InputLabel>
            <Select
              value={knowledgeBase.embedder_model}
              name="embedder_model"
              onChange={handleEmbedderSelect}
            >
              {embedders.map((item: any, index: number) => {
                return (
                  <MenuItem key={index} value={item.embedder}>
                    {item.embedder}
                  </MenuItem>
                );
              })}
            </Select>

          </FormControl>

          <FormControl
            fullWidth
            sx={{ mb: 1 }}
            error={knowledgeBaseErr.description.value}
          >
            <InputLabel
              shrink
              htmlFor="description"
              sx={{ background: "#fff", px: 0.5 }}
            >
              API Key *
            </InputLabel>
            <TextField
              name="api_key"
              value={knowledgeBase.api_key}
              placeholder="Enter API Key"
              onChange={handleChange}>
            </TextField>

          </FormControl>

          <KnowledgeBaseTabs
            setKnowledgeBase={setKnowledgeBase}
            knowledgeBase={knowledgeBase}
            knowledgeBaseDoc={knowledgeBaseDoc}
            setKnowledgeBaseDoc={setKnowledgeBaseDoc}
            setKnowledgeBaseCombine={setKnowledgeBaseCombine}
            knowledgeBaseCombine={knowledgeBaseCombine}
            setKnowledgeBasWebsite={setKnowledgeBasWebsite}
            setKnowledgeBaseSharePoint={setKnowledgeBaseSharePoint}
            knowledgeBaseSharePoint={knowledgeBaseSharePoint}
          />

          <Button
            sx={{
              mt: 2,
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              border: "1px solid #E0E0E0",
              borderRadius: "4px",
              p: 1.5,
              backgroundColor: "#F5F7FA",
              color: "#1D1D1D",
            }}
            onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            endIcon={
              <ExpandMoreIcon
                sx={{
                  transition: "transform 0.3s ease-in-out",
                  transform: showAdvancedOptions
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                }}
              />
            }
          >
            Advanced Options
          </Button>

          <AdvancedOptions
            setKnowledgeBase={setKnowledgeBase}
            knowledgeBase={knowledgeBase}
            showAdvancedOptions={showAdvancedOptions}
            knowledgeBaseErr={knowledgeBaseErr}
          />

          <Box
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button
              variant="outlined"
              disableElevation
              size="large"
              sx={{ textTransform: "capitalize" }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              size="large"
              disabled={disableSubmit}
              sx={{ textTransform: "capitalize" }}
              onClick={() =>
                isEditing ? updateKnowledgeBase() : createKnowledgeBase()
              }
            // disableElevation
            >
              {isEditing ? "Update" : "Create"}
            </Button>
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default KnowledgeBaseForm;
